<template>
  <div class="canvas" :id="flow" :ref="flow" @scroll="positionLine">
    <json-comp :json="flowJSON" v-show="showJSONComponent"></json-comp>
    <div class="navbarcomponent">
      <div class="list_item">

<div class="nav_component" id="menu" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="menu">{{ icon.menu }}</v-icon>

  </div>
  <div class="icon-txt">Menu</div>
</div>
<div class="nav_component" id="audio" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="audio">{{ icon.audio }}</v-icon>
  </div>
  <div class="icon-txt">Audio</div>
</div>
<div class="nav_component" id="sms" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="sms">{{ icon.sms }}</v-icon>
  </div>
  <div class="icon-txt">SMS</div>
</div>
<div class="nav_component" id="voicemail" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="voice">{{ icon.voicemail }}</v-icon>
  </div>
  <div class="icon-txt">Voice Mail</div>
</div>
<div class="nav_component" id="validation" @click="isNameChanged" draggable="true"
  @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="validation">{{ icon.validation }}</v-icon>
  </div>
  <div class="icon-txt">Validation</div>
</div>
<div class="nav_component" id="connection" @click="isNameChanged" draggable="true"
  @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="connection">{{ icon.connection }}</v-icon>
  </div>
  <div class="icon-txt">Connection</div>
</div>
<div class="nav_component" id="conference" @click="isNameChanged" draggable="true"
  @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="conference">{{ icon.conference }}</v-icon>
  </div>
  <div class="icon-txt">Conference</div>
</div>
<div class="nav_component" id="dial" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="dial">{{ icon.dial }}</v-icon>
  </div>
  <div class="icon-txt">Dial</div>
</div>
<div class="nav_component" id="hangup" @click="isNameChanged" draggable="true" @dragstart="dragFlow($event)">
  <div class="nav_items">
    <v-icon class="hangup">{{ icon.hangup }}</v-icon>
  </div>
  <div class="icon-txt">Hangup</div>
</div>
</div>
    </div>
    <div class="mainViewFlex" style="overflow: hidden; height: 97%; margin: 0px">
      <div style="
          overflow: hidden;
          height: calc(100% - 90px);
          position: relative;
          padding: 0px 5px 0px 5px;
        ">
        <div class="scrolling-canvas" ref="scrollDiv" @scroll="positionLine()" v-bind:style="[
          active ? { overflow: 'auto' } : { overflow: 'hidden' },
        ]">
          <div id="div1" @drop="drop($event)" @dragover="allowDrop($event)" @click.stop="hideFooter($event)" class="zoom">
            <slot name="flow"></slot>
            <vue-draggable-resizable v-for="(item, index) in shapes" :key="item.id" :min-width="150" :min-height="100"
              :w="item.w" :h="item.h" :x="item.x" :y="item.y" :class="{ check: true, highlight: item.showFooter }"
              class-name="flow" class-name-handle="custom-handle" :id="item.id" :ref="item.id"
              :draggable="item.draggable" :parent="true" @dragging="positionLine(index)" @resizing="positionLine(index)"
              @activated="activated(index, item)" @deactivated="item.showCircle = false" :active="item.showFooter"
              :style="{ backgroundColor: item.bgcolor, color: icon.bgcolor }">
              <div draggable="true" class="connect-arrow" @dragstart.stop="drag($event, index)"
                @mouseenter="disableDrag" @mouseleave="enableDrag" id="drag"
                v-show="item.showCircle && item.title != 'HANGUP'"></div>
              <div draggable="true" class="connect-arrow-f" @dragstart.stop="drag($event, index)"
                @mouseenter="disableDrag" @mouseleave="enableDrag" id="drag-f" v-show="item.showCircle &&
                  (item.title == 'MENU' ||
                    item.title == 'DIAL' ||
                    item.title == 'VALIDATION')
                  "></div>
              <div class="content" :id="item.id" @drop="dropArrow(item.id, $event, index, item)"
                @dragover="allowDrop($event,)">
                <div :id="item.id" class="content__header" :style="{ backgroundColor: item.bgcolor }">

                  <div>{{ item.title }}</div>
                  <div class="header-options">
                    <v-icon color="#fff" style="font-size: 15px" @click.stop="showFlowFooter(index)">edit</v-icon>
                    <v-icon color="#fff" style="font-size: 15px" v-if="item.data != 'trigger'"
                      @click.stop="removeFlow(index, item)">close</v-icon>
                  </div>
                </div>

                <div :id="item.id" class="content__description" @mouseover="fun()" @mouseleave="hii()">

                  <div style="font-size: 12px;font-weight: 600">
                    <v-icon class="icon">{{ icon[`${item.data}`] }}</v-icon>{{ item.id }}
                    <!-- <span class="name">{{ item.name }}</span> -->
                  
                  </div>
                 
                  <div class="description">{{ item.description }}</div>
                 {{  }}
                </div>
              </div>
            </vue-draggable-resizable>
          </div>
        </div>
        <!-- <div class="zoom_button_class">
          <v-btn fab samll fixed color="#2194f3" class="zoom-out-bts" @click="zoomOut()">
            <v-icon color="#fff" light>mdi-minus</v-icon>
          </v-btn>
          <v-btn fab samll fixed color="#2194f3" class="zoom-in-bts" @click="zoomIn()">
            <v-icon color="#fff" light>add</v-icon>
          </v-btn>
        </div> -->
      </div>
      <div class="upl_btn">
        <!-- <button class="bts_clss" @click="showJSONComponent = true" style="background: #2194f3; color: white">
 JSON
 </button> -->

        <div class="button_main_cls">
          <button class="bts_clss" @click="cancelFlow()" style="background: #2194f3; color: white">
            Cancel
          </button>
          <button class="bts_clss" @click="putJSON()" style="background: #2194f3; color: white">
            Update
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="upl_btn">
        <v-btn @click="putJSON()" style="background: #2194f3; color: white">
          Update
        </v-btn>
      </div>
    </div> -->
 
    <v-snackbar v-model="Snackbar.show" :bottom="true" :right="true" :timeout="Snackbar.timeout">
      {{ Snackbar.text }}
      <v-btn color="pink" flat @click="Snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="alert" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Alert! </span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text text-bold>{{ alertmessage }}</v-card-text>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closealert()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" right top color="#fff">
      <span style="color: #000">Zoom: {{ zoomalert }}</span>
    </v-snackbar>
    <!-- <div class="scrolling-canvas" ref="scrollDiv" @scroll="positionLine()">
      <div
        id="div1"
        @drop="drop($event)"
        @dragover="allowDrop($event)"
        @click.stop="hideFooter($event)"
        class="zoom"
      >
        <slot name="flow"></slot>
        <vue-draggable-resizable
          v-for="(item, index) in shapes"
          :key="item.id"
          :min-width="150"
          :min-height="100"
          :w="item.w"
          :h="item.h"
          :x="item.x"
          :y="item.y"
          :class="{ check: true, highlight: item.showFooter }"
          class-name="flow"
          class-name-handle="custom-handle"
          :id="item.id"
          :ref="item.id"
          :draggable="item.draggable"
          :parent="true"
          @dragging="positionLine(index)"
          @resizing="positionLine(index)"
          @activated="activated(index, item)"
          @deactivated="item.showCircle = false"
          :active="item.showFooter"
        >
          <div
            draggable="true"
            class="connect-arrow"
            @dragstart.stop="drag($event, index)"
            @mouseenter="disableDrag"
            @mouseleave="enableDrag"
            id="drag"
            v-show="item.showCircle"
          ></div>
          <div
            draggable="true"
            class="connect-arrow-f"
            @dragstart.stop="drag($event, index)"
            @mouseenter="disableDrag"
            @mouseleave="enableDrag"
            id="drag-f"
            v-show="
              item.showCircle &&
              (item.name == 'menu' ||
                item.name == 'dial' ||
                item.name == 'validation')
            "
          ></div>
          <div
            class="content"
            :id="item.id"
            @drop="dropArrow(item.id, $event, index)"
            @dragover="allowDrop($event)"
          >
            <div :id="item.id" class="content__header">
              <div>{{ item.title }}</div>
              <div class="header-options">
                <v-icon
                  color="#fff"
                  style="font-size: 15px"
                  @click.stop="showFlowFooter(index)"
                  >edit</v-icon
                >
                <v-icon
                  color="#fff"
                  style="font-size: 15px"
                  v-if="item.data != 'trigger'"
                  @click.stop="removeFlow(index, item)"
                  >close</v-icon
                >
              </div>
            </div>
            <div :id="item.id" class="content__description">
              <div>
                <v-icon>{{ icon[`${item.data}`] }}</v-icon>
                <span class="name">{{ item.name }}</span>
              </div>
              <div style="font-size: 10px">{{ item.id }}</div>
              <div class="description">{{ item.description }}</div>
            </div>
          </div>
        </vue-draggable-resizable>
      </div>
    </div> -->
    <!-- <v-btn fab samll fixed color="#2194f3" class="zoom-out" @click="zoomOut()">
      <v-icon color="#fff" light>mdi-minus</v-icon>
    </v-btn>
    <v-btn fab samll fixed color="#2194f3" class="zoom-in" @click="zoomIn()">
      <v-icon color="#fff" light>add</v-icon>
    </v-btn> -->

    <div v-for="(footer, index) in shapes" :key="`${index}_${footer.id}`">
      <div class="foot" v-show="footer.showFooter">
        <!-- <v-tabs v-model="props_tab_index" color="primary"  >
          <v-tab value="general">Item One</v-tab>
          <v-tab value="settings">Item Two</v-tab>
          <v-tab value="control">Item Three</v-tab>
        </v-tabs> -->

        <!-- <v-tabs   v-model="props_tab_index" color="primary" >
          <v-tab href="#general">General</v-tab>
          <v-tab href="#settings" v-show="footer.data != 'hangup'">Settings</v-tab>
          <v-tab href="#control" v-show="footer.data == 'menu'">Control</v-tab>
        </v-tabs> -->
       
        <div class="tabflex">
          <div @click="selecttab('general')" :class="{
            tabitem: props_tab_index === 'general',
            tabitempadding: true,
          }">
            General
          </div>
          <div v-if="footer.data != 'hangup' && footer.data != 'voicemail'" @click="selecttab('settings')" :class="{
            tabitem: props_tab_index === 'settings',
            tabitempadding: true,
          }">
            Settings
          </div>
          <div v-if="footer.data === 'menu'" @click="selecttab('control')" :class="{
            tabitem: props_tab_index === 'control',
            tabitempadding: true,
          }">
            Control
          </div>
        </div>
        <div v-if="props_tab_index == 'general'" class="fix-height">
          <div>
            <div class="input">
              <label for="title">Title</label>
              <input v-model="footer.name" type="text" name="title" id="title" placeholder="Enter title text" />
            </div>
            <div class="input">
              <label for="desc">Description</label>
              <textarea placeholder="Enter description text" v-model="footer.description" name="desc" id="desc" cols="44"
                rows="5"></textarea>
            </div>
          </div>
        </div>
        <div v-if="props_tab_index == 'control'" class="fix-height">
          <div class="menu-settings" v-if="footer.data == 'menu'">
            <div class="table-view-parallel">
              <table class="table">
                <thead>
                  <tr>
                    <th>Next</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(key, i) in footer.settings.choices" :key="i">
                    <td>
                      <div class="input">
                        <input width="50%" display="inline" v-model.number="footer.settings.keys[i]" @input="
                          menuControl(footer.settings.keys[i], footer.id, i)
                          " type="text" id="key" />
                      </div>
                    </td>
                    <td>
                      <v-select :items="menuItems" label="Components" item-text="name" item-value="value" return-object
                        v-model="footer.settings.choices[i]" @change="
                          checkValueExist(
                            footer.settings.choices[i],
                            footer.id,
                            i
                          )
                          " persistent-hint></v-select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
       
        <div v-if="props_tab_index == 'settings'" class="fix-height">
          <!-- <div class="dial-settings" v-show="footer.data == 'dial'">
                    {{footer.settings.dialType}}
                    <div class="input">
                        <label for="connection">Connection</label>
                        <selectcomponent text="name" value="value" :list="connections" :select="footer.settings.connection" @update="updateTriggerConnection" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Connection"></multiselectcomponent>
                    </div>
                    <div class="input">
                        <label for="type">Dial Type</label>
                        <multiselectcomponent text="name" value="value" :list="type" :select="footer.settings.type" @update="updateTriggerType" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Type"></multiselectcomponent>
                    </div>
                    <div class="input">
                        <label for="desc">DID</label>
                        <input v-model="footer.settings.did" type="text" name="desc" id="desc" placeholder="DID" />
                    </div>
                </div> -->
               
          <div v-if="footer.data == 'dial'">
            <div class="input_">
              <v-select :items="dialTypes" label="Select Dial Type" return-object v-model="dialtype"
                @change="dialconfig(dialtype, footer.id, 'dialType')" persistent-hint></v-select>
            </div>
            <div class="input_" v-if="footer.settings.dialType === 'Queue'">
              <v-select :items="queueTypes" label="Select Queue" return-object v-model="queue_"
                @change="dialconfig(queue_, footer.id, 'queue')" persistent-hint></v-select>
            </div>
            <div class="input_" v-if="footer.settings.dialType === 'Number'">
              <v-select :items="dialoptions" v-model="didnumbertype" @input="dialconfig(didnumbertype, footer.id, 'DID')"
                placeholder="Select Number"></v-select>
            </div>
            <div class="input" v-if="footer.settings.DID === 'Others' && dialtype==='Number'">
              <label for="caller">Number</label>
              <input v-model="didnumber" @input="dialconfig(didnumber, footer.id, 'DIDNumber')" type="text" name="caller"
                id="caller" placeholder="Enter Phone Number" />
            </div>
            <div class="input_" v-if="footer.settings.dialType === 'Queue' ||
              footer.settings.DID === 'Agent'
              ">
              <v-autocomplete v-model="agents" @input="dialconfig(agents, footer.id, 'users')" :items="userData"
                label="Choose Agent" persistent-hint item-text="user_name" key="user_name" return-object small multiple
                single-line :allow-overflow="false">
              </v-autocomplete>
            </div>
          </div>
          <!-- <div v-show="footer.data == 'hangup'">
            <div class="input">
                    <label for="success">Success</label>
                    <multi-select
                        id="success"
                        :options="elements"
                        v-model="footer.settings.success"
                        placeholder="Select next"
                    ></multi-select>
                    </div>
                    <div class="input">
                    <label for="failure">failure</label>
                    <multi-select
                        id="failure"
                        :options="elements"
                        v-model="footer.settings.failure"
                        placeholder="Select next"
                    ></multi-select>
                    </div> 
          </div> -->
          <div class="trigger-settings" v-else-if="footer.data == 'trigger'">
            <!-- <div class="input">
                        <label for="connection">Connection</label>
                        <multiselectcomponent text="name" value="value" :list="connections" v-model="footer.settings.connection" @update="updateTriggerConnection" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Connection"></multiselectcomponent>
                    </div>
                    <div class="input">
                        <label for="type">Type</label>
                        <multiselectcomponent text="name" value="value" :list="type" :select="footer.settings.type" @update="updateTriggerType" :alwaysopenlist="false" :maxSelectable="1" placeholder="Select Type"></multiselectcomponent>
                    </div> -->
            <div class="input">
              <label for="desc">DID</label>
              <input v-model="did_numbers" type="text" name="desc" id="desc" placeholder="Enter DID" />
            </div>
            <div class="input">
              <v-checkbox v-model="footer.settings.check_balance" label="Check Balance"></v-checkbox>
            </div>
            <div class="input" v-if="footer.settings.check_balance">
              <label for="balance">Balance</label>
              <input v-model="footer.settings.balance" type="number" name="balance" id="balance"
                placeholder="Enter Balance" />
            </div>
          </div>

          <div class="audio-settings" v-else-if="footer.data == 'audio'">
            <div class="input-view-parallel">
              <label style="font-size: 12px; padding: 10px">Type</label>
              <input type="radio" name="audioChooser" v-on:change="audioOptions" v-model="audioOption"
                value="upload_file" />
              <label style="font-size: 12px; padding: 5px">Upload File</label>
              <input type="radio" name="audioChooser" v-on:change="audioOptions" v-model="audioOption"
                value="choose_file" />
              <label style="font-size: 12px; padding: 5px">Choose File</label>
              <!-- <div class="input" v-if="audioUpload">
              <label for="file">Audio File</label>
              <input accept=".mp3,audio/*" @change="addFile" type="file" name="audio-audio_file" :id="footer.id" />
              
            </div> -->

              <div class="input" v-if="audioUpload">
                <label for="file">Audio File</label>
                <input accept=".mp3,audio/*" @change="addFile" type="file" name="audio-audio_file" :id="footer.id"
                  ref="fileInput" />
                <textarea v-model="audio_discription" name="audio_txt" id="audio_txt" cols="44" rows="5"
                  placeholder="Type Your Discription" style="margin-top: 5px"></textarea>
                <button @click="saveAudio()" class="bts_clss" style="background: #2194f3; color: white">
                  Save File
                </button>
              </div>
              <div class="input_" v-if="audioChoose">
                <label for="file">Audio File</label>
                <v-select :items="audioFiles" v-model="audioFile" @input="audioFilesUpload(audioFile, footer.id)"
                  placeholder="Select Audio File"></v-select>
              </div>
              <div class="input">
                <v-checkbox v-model="footer.settings.expect" :color="'primary'"
                  @change="checkDTMF(footer.settings.expect, footer.id)" label="Expect DTMF"></v-checkbox>
              </div>
              <!-- <div class="input">
                        <label for="timeout">Timeout</label>
                        <input v-model.number="footer.settings.timeout" type="number" name="timeout" id="timeout" placeholder />
                        seconds
                    </div> -->
              <!-- <div class="input">
                        <label for="repeat">Repeat</label>
                        <input v-model.number="footer.settings.repeat" type="number" name="repeat" id="repeat" />
                        times
                    </div> -->
              <!-- <div class="input">
                        <v-checkbox v-model="footer.settings.skip" label="Skip on DTMF"></v-checkbox>
                    </div>
                    <div class="input">
                        <v-checkbox v-model="footer.settings.expect" label="Expect DTMF"></v-checkbox>
                    </div> -->
            </div>
          </div>
          <div class="vmail-settings" v-else-if="footer.data == 'voicemail'">
            <div class="input">
              <label for="vmail_num">Number</label>
              <input v-model="footer.settings.vmail_num" type="text" name="vmail_num" id="vmail_num"
                placeholder="Enter Phone Number" />
            </div>
          </div>
          <div class="sms-settings" v-else-if="footer.data == 'sms'">
            <!-- <div class="input">
              <label for="sms_opt">SMS</label>
              <multi-select
                id="sms_opt"
                :options="smsTypes"
                v-model="footer.settings.sms_opt"
                placeholder="Select Sms Option"
              ></multi-select>
            </div>
            <div class="input" v-if="footer.settings.sms_opt === 'Others'">
              <label for="sms_num">Number</label>
              <input
                v-model="footer.settings.sms_num"
                type="text"
                name="sms_num"
                id="sms_num"
                placeholder="Enter Phone Number"
              />
            </div> -->

            <div class="input">
              <label for="sms_api">SMS API</label>
              <input v-model="footer.settings.sms_api" type="text" name="sms_api" id="sms_api"
                placeholder="Enter API URL" />
            </div>
            <div class="input">
              <label for="sms_txt">Message</label>
              <textarea v-model="footer.settings.sms_txt" name="sms_txt" id="sms_txt" cols="44" rows="5"
                placeholder="Type Your Message"></textarea>
            </div>s
          </div>
          <div class="conference-settings" v-else-if="footer.data == 'conference'">
            <div class="input">
              <label for="conf_num">Bridge Number</label>
              <input v-model="footer.settings.conf_num" type="text" name="conf_num" id="conf_num"
                placeholder="Enter Phone Number" />
            </div>
          </div>
          <div class="validation-settings" v-else-if="footer.data == 'validation'">
            <div class="input">
              <label for="time_cond">Time Condition</label>
              <input v-model="footer.settings.time_from" type="time" name="time_from" id="time_from" placeholder="From" />
              <input v-model="footer.settings.time_to" type="time" name="time_to" id="time_to" placeholder="To" />
            </div>
            <div class="input_table">
              <div class="validationheader validation-settings">
                <div>
                  <label for="validate_param">Validate</label>
                </div>
                <div>
                  <Button class="add-button" @click="addSection(footer.id)">Add</Button>
                </div>
              </div>

              <div v-for="(key, i) in footer.settings.rules" :key="i" class="validation_row">
                <div class="validationheader validation-settings">
                  <div>
                    <label for="validate_param">Validate -{{ i + 1 }}</label>
                  </div>
                  <div>
                    <Button class="add-button" v-if="i !== 0" @click="removeSection(footer.id, i)">Delete</Button>
                  </div>
                </div>

                <div>
                  <v-select v-model="footer.settings.rules[i].parameter" :items="variables" name="validate_param" @change="
                    add_validate(
                      'param',
                      footer.id,
                      i,
                      footer.settings.rules[i].parameter
                    )
                    " id="validate_param" placeholder="Param" />
                </div>
                <div>
                  <v-select v-model="footer.settings.rules[i].operation" :items="operations" name="operation" @change="
                    add_validate(
                      'opera',
                      footer.id,
                      i,
                      footer.settings.rules[i].operation
                    )
                    " id="operation" placeholder="Operation" />
                </div>
                <div>
                  <input v-model="footer.settings.rules[i].value" type="text" name="validate_value" @change="
                    add_validate(
                      'value',
                      footer.id,
                      i,
                      footer.settings.rules[i].value
                    )
                    " id="validate_value" placeholder="Value" class="custom-input" />
                </div>
              </div>
            </div>
          </div>
          <div class="connection-settings" v-else-if="footer.data == 'connection'">
            <div class="input_">
              <label for="conn_method">Connection</label>
              <v-select v-model="footer.settings.conn_method" :items="connMethods" name="connMethods" id="conn_method"
                placeholder="Select Connection Method" />

            </div>
            <div class="input_">
              <label for="conn_type">Type</label>
              <v-select v-model="footer.settings.conn_type" :items="connTypes" name="connTypes" id="conn_type"
                placeholder="Select Connection Type" />

            </div>
            <div class="input">
              <label for="conn_api">API</label>
              <input v-model="footer.settings.conn_api" type="text" name="conn_api" id="conn_api"
                placeholder="Enter API URL" />
            </div>
            <!-- <div class="input">
              <label for="conn_res">Response</label>
              <textarea @change="add_response(footer.id, footer.settings.conn_res)" v-model="footer.settings.conn_res"
                name="conn_res" id="conn_res" cols="44" rows="3" placeholder="Enter Response"></textarea>
            </div> -->
            <div class="input_table">
              <div class="validationheader validation-settings">
                <div>
                  <label for="validate_param">Parameters</label>
                </div>
                <div>
                  <Button class="add-button" @click="addParametersSection(footer.id)">Add</Button>
                </div>
              </div>

              <div v-for="(key, i) in footer.settings.api_param" :key="i" class="validation_row">
                <div class="validationheader validation-settings">
                  <div>
                    <label for="validate_param">Parameters -{{ i + 1 }}</label>
                  </div>
                  <div>
                    <Button class="add-button" v-if="i !== 0"
                      @click="removeParametersSection(i, footer.id)">Delete</Button>
                  </div>
                </div>
                <div>
                  <input v-model="footer.settings.api_param[i]" type="text" name="api_param" @change="
                    add_params(
                      'key',
                      footer.id,
                      i,
                      footer.settings.api_param[i]
                    )
                    " id="api_param" placeholder="Key" class="custom-input" />
                </div>
                <div>
                  <v-select v-if="valueDrop[i]" v-model="footer.settings.api_value[i]" :items="variables" name="api_value"
                    @change="
                      add_params(
                        'value',
                        footer.id,
                        i,
                        footer.settings.api_value[i]
                      )
                      " id="api_value" placeholder="Value" />
                  <input v-if="valueText[i]" v-model="footer.settings.api_value[i]" type="text" name="api_value" @change="
                    add_params(
                      'value',
                      footer.id,
                      i,
                      footer.settings.api_value[i]
                    )
                    " id="api_value" placeholder="Value" />
                </div>
              </div>

            </div>
          </div>
          <div class="menu-settings" v-else-if="footer.data == 'menu'">
            <div class="input-view-parallel">
              <input type="radio" name="menuChooser" v-on:change="menuOptions" v-model="radioOption"
                value="upload_file" />
              <label style="font-size: 12px; padding: 5px">Upload File</label>
              <input type="radio" name="menuChooser" v-on:change="menuOptions" v-model="radioOption"
                value="choose_file" />
              <label style="font-size: 12px; padding: 5px">Select File</label>
              <div class="check" v-if="menuUpload">
                <div class="input_">
                  <label for="file">Select Audio Type</label>
                  <v-select :items="audiotypearray" v-model="audiotype" placeholder="Audio Type"
                    @input="selectaudiotype('invalid', menuInvalid, footer.id)"></v-select>
                </div>
                <div v-if="audiotype === 'Menu Audio'" class="input">
                  <label for="file">Menu Audio File</label>
                  <input accept=".mp3,audio/*" @change="addFile" type="file" name="menu-audio_file" :id="footer.id" />
                  <textarea v-model="audio_discription" name="audio_txt" id="audio_txt" cols="44" rows="5"
                    placeholder="Type Your Discription" style="margin-top: 5px"></textarea>
                  <button @click="saveAudio()" class="bts_clss" style="background: #2194f3; color: white">
                    Save File
                  </button>
                </div>
                <div v-if="audiotype === 'Invalid Audio'" class="input">
                  <label for="file">Invalid Audio File</label>
                  <input accept=".mp3,audio/*" @change="addFile" type="file" name="menu-invalid_file" :id="footer.id" />
                  <textarea v-model="audio_discription" name="audio_txt" id="audio_txt" cols="44" rows="5"
                    placeholder="Type Your Discription" style="margin-top: 5px"></textarea>
                  <button @click="saveAudio()" class="bts_clss" style="background: #2194f3; color: white">
                    Save File
                  </button>
                </div>
              </div>
              <div class="check" v-if="menuChoose">
                <div class="input_">
                  <label for="file">Menu Audio File</label>
                  <v-select :items="audioFiles" v-model="menuValid" @input="menuFiles('valid', menuValid, footer.id)"
                    placeholder="Select Audio File"></v-select>
                </div>
                <div class="input_">
                  <label for="file">Invalid Audio File</label>
                  <v-select :items="audioFiles" v-model="menuInvalid" placeholder="Select Audio File"
                    @input="menuFiles('invalid', menuInvalid, footer.id)"></v-select>
                </div>
              </div>
              <!-- <div class="input">
              <label for="file">Timeout Audio File</label>
              <input
                accept=".mp3,audio/*"
                @change="addFile"
                type="file"
                name="menu-timeout_file"
                :id="footer.id"
              />
              <span
                v-if="footer.settings['menu-timeout_file']"
                style="font-size: x-small; color: #1ac43c"
                >{{ footer.settings["menu-timeout_file"] }}</span
              >
            </div> -->
              <div class="input">
                <label for="file">Timeout (seconds)</label>
                <input v-model.number="footer.settings.timeout" type="number" name="repeat" id="repeat" />
              </div>
              <div class="input">
                <label for="file">Repeat (times)</label>
                <input v-model.number="footer.settings.repeat" type="number" name="repeat" id="repeat" />
              </div>
              <!-- <div class="input">
              <v-checkbox
                v-model="footer.settings.skip"
                label="Skip on DTMF"
              ></v-checkbox>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import VueDraggableResizable from "vue-draggable-resizable";
// import multiselectcomponent from "@/components/multiselect.vue";
import LeaderLine from "leader-line-vue";
import { mapGetters } from "vuex";
import { isNumber } from "util";
import JsonComp from "./json";
import api from "@/utils/axios-util";
import { validation_function } from "../CallFlowValidation";
export default {
  props: ["flow", "lines", "showJSON"],
  components: {
    JsonComp: JsonComp,
    "vue-draggable-resizable": VueDraggableResizable,
  },
  data() {
    return {
      
      dialoptions: ['Dial Status',"Agent", "Others"],
      dialtype: "",
      queue_: "",
      didnumbertype: "",
      didnumber: "",
      agents: "",

      audiofileFormdata: "",
      audio_discription: "",
      audioname: "",
      audioid: "",

      did_numbers: "",
      active: true,
      presetLine: [
        { type: "l", site: 100 },
        { type: "v", site: 200 },
      ],
      width: 60,
      height: 60,
      x: 0,
      y: 0,
      props_tab_index: "general",
      tenant_code: "",
      
      icon: {
        dial: "fa-solid fa-phone",
        audio: "fa-volume-up",
        trigger: "bolt",
        menu: "fa-solid fa-bars",
        sms: "fas fa-sms",
        voicemail: "fa-solid fa-microphone",
        validation: "fas fa-check-circle",
        connection: "fa fa-random",
        conference: "fa fa-users",
        hangup: "fas fa-phone-slash",
      },
      bgcolor: {
        dial: "#32cd32",
        sms: "#1da1f2",
        audio: "#ffa500",
        menu: "#4a4a4a",
        voicemail: "#8a2be2",
        validation: "#28a745",
        connection: "#20c997",
        conference: "#008080",
        hangup: "#ff4b4b"
      },
      options: {
        dial: {
          queueType: "",
          queue: "",
        },
        // hangup: {
        //     success: "",
        //     failure: ""
        // },
        audio: {
          audio: "",
          timeout: "",
          repeat: "",
          // skip: false,
          // expect: true
        },
        voicemail: {
          vmail_num: "",
        },
        sms: {
          sms_opt: "",
          sms_num: "",
          sms_txt: "",
          sms_api: "",
        },
        validation: {
          rules: [
            {
              parameter: "",
              operation: "",
              value: "",
            },
          ],
          time_from: "",
          time_to: "",
        },
        connection: {
          conn_method: "",
          conn_type: "",
          conn_api: "",
          api_param: [],
          api_value: [],
        },
        conference: {
          conf_num: "",
        },
        trigger: {
          connection: "",
          type: "",
          did: "",
        },
        menu: {
          choices: [
            {
              key: 1,
              value: "",
            },
          ],
          keys: [1],
          files: {
            menu_valid: "",
            menu_invalid: "",
          },
        },
        // crm: {}
      },
      menuItems: [],
      connections: [
        { name: "Option 1", value: "option1" },
        { name: "Option 2", value: "option2" },
        { name: "Option 3", value: "option3" },
      ],
      type: [
        { name: "Inbound", value: "inbound" },
        { name: "Outbound", value: "outbound" },
      ],
      elements: ["trigger"],
      dialTypes: ["Queue", "Number"],
      queueTypes: ["Queue1", "Queue2"],
      smsTypes: ['Dial Status',"Caller", "Agent", "Others"],
      connMethods: ["GET", "POST", "PUT", "DELETE"],
      connTypes: ["TEXT", "JSON", "XML", "Form-urlencoded"],
      variables: ["DID Number", 'Dial Status',"Caller", "Agent", 'Others'],
      valueText: [false],
      valueDrop: [true],
      audioFiles: [],
      shapeCount: 1,
      shapes: [
        {
          id: `CTI-${this.flow.name}-trigger0`,
          data: "trigger",
          name: "trigger",
          x: 45,
          y: 18,
          w: 150,
          h: 100,
          title: "TRIGGER",
          description: "Description",
          draggable: true,
          showFooter: false,
          showCircle: false,
          settings: {
            connection: [],
            type: [],
            did: "",
          },
          next: {
            success: "",
            failure: "",
          },
        },
      ],
      operations: [
        "LIKE",
        "LIKE %...%",
        "NOT LIKE",
        "IN",
        "NOT IN",
        "IS NULL",
        "IS NOT NULL",
        "BETWEEN",
        "NOT BETWEEN",
        "=",
        ">",
        "<",
        ">=",
        "<=",
        "!=",
      ],
      line: [],
      audiotype: "",
      audiotypearray: ["Menu Audio", "Invalid Audio"],
      radioOption: "upload_file",
      audioOption: "upload_file",
      audioChoose: false,
      audioUpload: true,
      menuUpload: true,
      menuChoose: false,
      menuValid: "",
      menuInvalid: "",
      audioFile: "",
      start: "",
      end: "",
      showCircle: false,
      showFooter: false,
      zoom: "",
      connectors: [],
      Snackbar: {
        show: false,
        timeout: 1000,
        text: "",
      },
      flowJSON: {},
      showJSONComponent: false,
      alert: false,
      alertmessage: "",
      lineColor: "#000",
      lineType: "success",
      currentFlow: 0,
      offsetX: 0,
      offsetY: 0,
      selectedFlow: 0,
      highlightedFlowIndex: -1,
      zoomProperties: {
        defaults: {
          chrome: {
            browser: "chrome",
            zoom: 100,
            default: 100,
            step: 10,
            suffix: "%",
            prefix: "",
            property: "zoom",
            min: 30,
            max: 200,
            unit: 1,
          },
          firefox: {
            browser: "firefox",
            zoom: 1,
            default: 1,
            step: 0.1,
            suffix: ")",
            prefix: "scale(",
            property: "MozTransform",
            min: 0.5,
            max: 2,
            unit: 100,
          },
        },
        current: {},
      },
      snackbar: false,
      activatedIndex: null,
      userData: [],
    };
  },
  created() {
    let scope = this;
    if (scope.updateJSON) {
      var json = JSON.stringify(scope.updateJSON);
      json = JSON.parse(json);
      scope.flow_id = json.flow_id;
      scope.renderFlow(scope.updateJSON);
    }
  },
  mounted() {
    let scope = this;

    scope.tenant_code = localStorage.getItem("TenantCode");
    for (let i = 0; i < this.shapes.length; i++) {
      const element = this.shapes[i];
      if (element.data === "menu") {
        if (
          element.settings.files.menu_valid !== undefined &&
          element.settings.files.menu_valid !== "" &&
          element.settings.files.menu_valid
        ) {
          this.menuValid = element.settings.files.menu_valid.replace(
            this.tenant_code + "_",
            ""
          );
          this.menuFiles(
            "valid",
            element.settings.files.menu_valid.replace(
              this.tenant_code + "_",
              ""
            ),
            element.id
          );
        }
        if (
          element.settings.files.menu_invalid !== undefined &&
          element.settings.files.menu_invalid !== "" &&
          element.settings.files.menu_invalid
        ) {
          this.menuFiles(
            "invalid",
            element.settings.files.menu_invalid.replace(
              this.tenant_code + "_",
              ""
            ),
            element.id
          );
          this.menuInvalid = element.settings.files.menu_invalid.replace(
            this.tenant_code + "_",
            ""
          );
        }
      }
    }
    this.audioOptions();
    this.menuOptions();
    scope.findAudio();
    var json = JSON.stringify(scope.updateJSON);
    json = JSON.parse(json);
    scope.shapeCount = Object.keys(json.data.values).length + 1;
    console.log(scope.flow, "json.namejson.namejson.name", json);
    scope.flow.name = json.name;
    scope.isNameChanged();
    var connections = json.data.connections;
    // scope.variables = json.data.variable;
    scope.drawLines(connections);

    var isFirefox = typeof InstallTrigger !== "undefined";
    var isChrome =
      !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    let browser = "";
    if (isChrome) {
      browser = "chrome";
    } else if (isFirefox) {
      browser = "firefox";
    }
    if (browser !== "") {
      scope.zoomProperties.current = scope.zoomProperties.defaults[browser];
    }

    scope.$store
      .dispatch("queueManagement", { name: "", take: 100, skip: 0 })
      .then((response) => {
        if (response.data.statusCode === 200) {
          const qType = response.data.data;
          var qTypes = [];
          qType.forEach((q) => {
            qTypes.push(q.name);
          });
          scope.queueTypes = qTypes;
        }
      });
    scope.$store
      .dispatch("userManagement", { skip: 0, take: 100 })
      .then((response) => {
        if (response.data.statusCode === 200) {
          scope.userData = response.data.data.map((user) => {
            return {
              phone_number: user.user_phone_number,
              user_name: user.user_email,
            };
          });
        }
      });
    // this.positionLine(0)
  },

  updated() {
    let scope = this;

    scope.updateJSON.name = scope.flow.name;
  },
  methods: {
    addParametersSection(val) {
      console.log(val, "footer.settings.api_paramfooter.settings.api_param")
      var scope = this;
      
      scope.shapes.map(function (shape) {

        if (shape.id == val) {
          shape.settings.api_param.push("")
          shape.settings.api_value.push("");
        }
        return shape;
      });
    },
    removeParametersSection(id, footer_id) {
      console.log(id)
      var scope = this;
      
      scope.shapes.map(function (shape) {

        if (shape.id == footer_id) {
          let arr = []
          let arr2=[]
          for (let i = 0; i < shape.settings.api_param.length; i++) {
            const element = shape.settings.api_param[i];
            const element_= shape.settings.api_value[i]
            if (i !== id) {
              arr.push(element)
              arr2.push(element_)
            }

          }
          shape.settings.api_param = arr
          shape.settings.api_value = arr2
        }
        return shape;
      });
    },
    selecttab(data) {
      console.log(data,"eeeeeeeeeeeeeeeeeeeeeeee")
      this.props_tab_index = data;

    },
    selectaudiotype() {
      this.audiofileFormdata = "";
      this.audio_discription = "";
      this.audioname = "";
      this.audioid = "";
    },
    saveAudio() {
      this.audiofileFormdata.append("description", this.audio_discription);
      api.defaults.headers["Content-Type"] = "multipart/form-data";
      api
        .post("/audio", this.audiofileFormdata)
        .then((response) => {
          api.defaults.headers["Content-Type"] = "application/json";
          const file_name = response.data.insert.file_name;
          this.shapes.map((shape) => {
            if (shape.id == this.audioid) {
              if (this.audioname.split("-")[0] == "menu") {
                if (this.audioname == "menu-audio_file") {
                  shape.settings.files.menu_valid = file_name;
                }
                if (this.audioname == "menu-invalid_file") {
                  shape.settings.files.menu_invalid = file_name;
                }
                console.log("file", file_name);
              }
              if (this.audioname.split("-")[0] == "audio") {
                shape.settings.audio = file_name;
              }
            }
          });
          console.log("name", this.audioname);
          var leng = this.tenant_code.length;
          if (this.audioname.split("-")[0] == "audio") {
            this.audioFile = file_name.substring(leng + 1);
          }
          if (this.audioname == "menu-audio_file") {
            this.menuValid = file_name.substring(leng + 1);
          }
          if (this.audioname == "menu-invalid_file") {
            this.menuInvalid = file_name.substring(leng + 1);
          }
          this.audiofileFormdata = "";
          this.audio_discription = "";
          this.audioname = "";
          this.audioid = "";
          this.audioOption = "choose_file";
          this.radioOption = "choose_file";
          this.audioOptions();
          this.menuOptions();
          this.findAudio();
        })
        .catch((error) => {
          console.log(error);
          this.audiofileFormdata = "";
          this.$refs.fileInput.value = null;
          api.defaults.headers["Content-Type"] = "application/json";
          this.showSnackBar(error);
        });
    },
    validateInput(inputElement) {
      console.log(":ffffffffff", inputElement);
    },
    cancelFlow() {
      var scope = this;
      scope.$router.push({ name: "CallFlow" });
    },
    closealert() {
      this.alert = false;
    },
    checkDTMF(bool, id) {
      let dtmf = id + ".dtmf";
      if (bool == true) {
        this.variables.push(dtmf);
      } else if (bool == false) {
        let index = this.variables.indexOf(dtmf);
        this.variables.splice(index, 1);
      }
    },
    add_response(id, value) {
      let var_len = this.variables.length;
      let temp = [];
      for (let j = 0; j < var_len; j++) {
        if (this.variables[j].indexOf(id) > -1) {
          temp.push(this.variables[j]);
        }
      }
      this.variables = this.variables.filter((name) => {
        return !temp.includes(name);
      });
      let values = value.split(",");
      for (let i = 0; i < values.length; i++) {
        let v = id + "." + values[i];
        this.variables.push(v);
      }
    },
    removeSection(id, index) {
      var scope = this;

      scope.shapes.map(function (shape) {
        if (shape.id == id) {
          let arr = [];
          for (let j = 0; j < shape.settings.rules.length; j++) {
            console.log(shape.settings.rules, "shape.settings.rules");
            if (j !== index) {
              arr.push(shape.settings.rules[j]);
            }
          }
          shape.settings.rules = arr;
        }

        return shape;
      });
    },
    addSection(id) {
      var scope = this;
      console.log(id);
      scope.shapes.map(function (shape) {
        if (shape.id == id) {
          let temp = {
            parameter: "",
            operation: "",
            value: "",
          };
          shape.settings.rules.push(temp);
        }

        return shape;
      });
    },
    add_validate(typ, id, index, val) {
      var scope = this;
      if (typ == "param") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            if (shape.settings.rules[index] === undefined) {
              shape.settings.rules[index] = {
                parameter: "",
                operation: "",
                value: "",
              };
            }
            shape.settings.rules[index].parameter = val;
          }
          return shape;
        });
      }
      if (typ == "opera") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.rules[index].operation = val;
          }
          return shape;
        });
      }
      if (typ == "value") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.rules[index].value = val;
          }
          return shape;
        });
      }
    },
    add_params(typ, id, index, val) {
      var scope = this;
      if (val === "Others") {
        scope.valueDrop[index] = false;
        scope.valueText[index] = true;
      }
      if (val !== "" && val !== undefined && typ == "key") {
        scope.valueText.push(false);
        scope.valueDrop.push(true);
      }
      if (typ == "key") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.api_param[index] = val;
            // shape.settings.api_param[index + 1] = "";
          }
          return shape;
        });
      }
      if (typ == "value") {
        scope.shapes.map(function (shape) {
          if (shape.id == id) {
            shape.settings.api_value[index] = val;
            // shape.settings.api_value[index + 1] = "";
          }
          return shape;
        });
      }
    },
    checkValueExist(selectData, id, index) {
      //this function is used to prevent duplicate value in dropdown menu item in sitting tab
      var scope = this;
      scope.line.map((obj) => {
        if (id === obj.endLabel) {
          obj.setOptions({ startLabel: index });
        }
      });
      scope.shapes.map(function (shape) {
        if (shape.id == id) {
          for (let i = 0; i < shape.settings.choices.length; i++) {
            if (i != index && shape.settings.choices[i].value == selectData) {
              shape.settings.choices[i].value = "";
            }
          }
        }
        return shape;
      });
    },
    isNameChanged() {
      //this function is used for to check flow or file name is changed or not
      if (this.flow.name.substr(0, this.flow.name.length - 1) == "Untitled") {
        this.show = !this.show;
      }
    },
    menuControl(data, id, key) {
      let _data = "";
      console.log(data, "datadatadatadatadata");
      if (
        data === "*" ||
        data === "#" ||
        (Number(data) >= 0 && Number(data) <= 9)
      ) {
        console.log(data, "datadatadatadatadata1111111", Number(data));
        _data = data;
      } else {
        _data = "";
      }
      var scope = this;
      scope.shapes.map(function (shape) {
        console.log(id, "datadatadatadatadata222222", shape);
        if (shape.id == id) {
          shape.settings.keys[key] = _data;
        }
        return shape;
      });
    },
    renderFlow(json) {
      let scope = this;
      scope.shapes = [];
      console.log(json, "json.data.startjson.data.startjson.data.start");
      scope.shapes[0] = json.data.start;

      var values = json.data.values;
      var keys = Object.keys(values);

      keys.forEach((element) => {
        scope.shapes.push(values[element]);
      });
      scope.shapes.forEach((shape) => {
        if (shape.data === "trigger") {
          this.did_numbers = shape.settings.did;
        }
        if (shape.data === "connection") {
          if (shape.settings.api_param.length > 0) {
            for (let j = 0; j < shape.settings.api_value.length; j++) {
              if (shape.settings.api_value[j] !== "") {
                // scope.variables.push(shape.settings.api_value[j]);
                scope.valueDrop.push(true);
              }
            }
          } else {
            shape.settings.api_param.push("");
          }
        }
        // else if (shape.name === "audio" && shape.settings.expect) {
        //   let dtmf = shape.id + ".dtmf";
        //   scope.variables.push(dtmf);
        // }
        else if (
          shape.data === "validation" &&
          shape.settings.rules.length > 1
        ) {
          let temp = {
            parameter: "",
            operation: "",
            value: "",
          };
          shape.settings.rules.push(temp);
          // for (let k = 0; k < shape.settings.rules.length; k++) {
          //   if (shape.settings.rules[k].parameter !== "") {
          //     scope.variables.push(shape.settings.rules[k].parameter);
          //   }
          // }
        }
        return shape;
      });
    },
    drawLines(connections) {
      try {
        let scope = this;
        // let connection = [];
        for (let i = 0; i < connections.length; i++) {
          var start = connections[i].start;
          var end = connections[i].end;

          if (start.split("-")[2].substring(0, 4) == "menu" && end) {
            scope.menuItems.push(end);
          }
          var tempShape = scope.shapes;
          scope.lineColor = "#000";

          for (let i = 0; i < tempShape.length; i++) {
            if (tempShape[i].id == start && tempShape[i].next.success == end) {
              scope.lineColor = "#000";
            }
            if (tempShape[i].id == start && tempShape[i].next.failure == end) {
              scope.lineColor = "#f00";
            }
          }

          scope.line[i] = new LeaderLine.setLine(
            document.getElementById(start),
            document.getElementById(end),
            {
              path: "grid",
              color: scope.lineColor,
              endPlus: "arrow3",
              size: 1.5,
              // endLabel: end,
            }
          );

          this.line.splice(this.line.length, 1, this.line);
          let div = document.querySelector("#div1");
          let lines = document.querySelectorAll(".leader-line");
          lines.forEach((line, index) => {
            line.style.zoom = div.style.zoom;
            line.addEventListener("click", async () => {
              await this.highlightLine(index);
            });
          });
          // this.$emit("addLine", this.line[i]);
        }
        this.line.pop();
        this.$refs.scrollDiv.scrollTo(50, 20);
        this.$refs.scrollDiv.scrollTo(0, 0);
        // scope.line.position();
        this.line.forEach((obj) => {
          obj.position();
        });
      } catch (err) {
        console.log(err, "eeeeetteeeeeeeeeeeeeeeeeeeeeeeeeeee");
      }
    },
    updateTriggerConnection() { },
    updateTriggerType() { },

    showFlowFooter(index) {
    console.log(index)
      this.props_tab_index = "general";
      this.audioFile = "";
      this.shapes.forEach((shape, i) => {
        shape.showFooter = false;

        if (shape.data === "audio" && index === i) {
          console.log(
            shape.settings,
            "showFootershowFootershowFootershowFooter",
            i,
            index
          );
          this.audioFile = shape.settings.audio.split(
            `${this.tenant_code}_`
          )[1];
        }
        if (shape.data === "menu" && index === i) {
          console.log(shape.settings);
          this.menuInvalid = shape.settings.files.menu_invalid.split(
            `${this.tenant_code}_`
          )[1];
          this.menuValid = shape.settings.files.menu_valid.split(
            `${this.tenant_code}_`
          )[1];
        }
        if (shape.data === "dial" && index === i) {
          this.dialtype = shape.settings.dialType;
          this.queue_ = shape.settings.queue;
          this.didnumbertype = shape.settings.DID;
          this.didnumber = shape.settings.DIDNumber;
          this.agents = shape.settings.users;
        }
      });
      this.shapes[index].showFooter = !this.shapes[index].showFooter;
    },
    positionLine(selectedFlow) {
      console.log("ev", selectedFlow, isNumber(selectedFlow));
      if (isNumber(selectedFlow)) {
        this.scrollPage(selectedFlow);
      }
      if (this.line) {
        this.line.forEach((currentLine) => {
          currentLine.position();
        });
      }
    },

    audioOptions() {
      if (this.audioOption == "choose_file") {
        this.findAudio();
        this.audioUpload = false;
        this.audioChoose = true;
      }
      if (this.audioOption == "upload_file") {
        this.audioChoose = false;
        this.audioUpload = true;
      }
    },
    audioFilesUpload(value, id) {
      this.shapes.forEach((shape) => {
        if (shape.id == id) {
          shape.settings.audio = this.tenant_code + "_" + value;
        }
      });
    },
    dialconfig(value, id, params) {
      this.shapes.forEach((shape) => {
        console.log(
          shape.id == id,
          shape.id,
          id,
          "33333333333333333333333333333333333333333"
        );
        if (shape.id == id) {
          shape.settings[`${params}`] = value;
        }
      });
    },
    menuOptions() {
      if (this.radioOption == "choose_file") {
        this.audiotype = "";
        this.findAudio();
        this.menuUpload = false;
        this.menuChoose = true;
      }
      if (this.radioOption == "upload_file") {
        this.menuChoose = false;
        this.menuUpload = true;
      }
    },
    findAudio() {
      var scope = this;
      let data = "Active";
      scope.$store.dispatch("FindAudio", data).then((response) => {
        var len = this.tenant_code.length;
        var datas = response.data.records;
        if (datas !== "" && datas !== undefined && datas !== null) {
          datas.forEach((element) => {
            scope.audioFiles.push(element["file_name"].substring(len + 1));
          });
        }
      });
    },
    scrollPage(index) {
      const flowId = this.shapes[index].id,
        flow = this.$refs[`${flowId}`],
        // div = this.$refs[`${this.flow}`],
        flowBottom = flow[0].$el.getBoundingClientRect().bottom,
        flowRight = flow[0].$el.getBoundingClientRect().right,
        screenBottom = window.innerHeight,
        screenRight = window.innerWidth;
      if (screenBottom - flowBottom < 200) {
        scrollBy(0, 50);
        this.shapes[index].showFooter = false;
      } else if (screenBottom - flowBottom > 400) {
        scrollBy(0, -50);
      }
      if (screenRight - flowRight < 200) {
        scrollBy(50, 0);
      } else if (screenRight - flowRight > 500) {
        scrollBy(-50, 0);
      }
    },
    addFile(event) {
      console.log("4", this.audio_discription);
      // this function is used to upload audio files in settings
      // var scope = this;
      let selectedFile = event.target.files[0];
      if (selectedFile.size <= 5000000) {
        let attribute = event.target.attributes;
        this.audioname = attribute.name.nodeValue;
        this.audioid = attribute.id.nodeValue;
        let formData = new FormData();
        formData.append("file_name", selectedFile);
        formData.append("status", "Active");
        this.audiofileFormdata = formData;
      } else {
        this.showSnackBar("File Size Must be Below 5MB");
      }
    },
    dragFlow(ev) {
      console.log(ev, "ev");
      // if(this.shapes.length > 4){
      //   this.active = true;
      // }
      this.isNameChanged();
      ev.dataTransfer.setData("text/html", ev.target.id);
      var crt = ev.target.cloneNode(true);
      crt.style.border = "1px dotted black";
      crt.style.width = "150px";
      crt.style.height = "150px";
      crt.style.borderRadius = "8px";
      document.body.appendChild(crt);
      ev.dataTransfer.setDragImage(crt, 0, 0);
    },
    disableDrag() {
      this.shapes.forEach((shape) => {
        shape.draggable = false;
      });
    },
    enableDrag() {
      this.shapes.forEach((shape) => {
        shape.draggable = true;
      });
    },
    drag(ev, index) {
      console.log(ev, index, "hhhhhhhhhhhhhhhhhhhhhhhhh");
      ev.stopPropagation();
      ev.dataTransfer.setData("text", "foo");
      this.start = ev.target.parentNode.id;
      let el = ev.target.id;
      if (el == "drag-f") {
        this.lineColor = "#f00";
        this.lineType = "failure";
      } else {
        this.lineColor = "#000";
        this.lineType = "success";
      }
      this.currentFlow = index;
    },
    allowDrop(ev) {
      ev.preventDefault();
    },
    dropArrow(id, ev, index) {
      try {
        let isDroppable = true,
          scope = this;
        const flow = this.shapes[this.currentFlow];
        this.shapes.forEach((shape) => {
          shape.showFooter = false;
          shape.draggable = true;
        });
        ev.preventDefault();
        this.end = ev.target.parentNode.id;
        this.line.forEach((line) => {
          let end = line.end.id,
            start = line.start.id;
          if (
            (start == this.end && end == this.start) ||
            (start == this.start && end == this.end)
          ) {
            isDroppable = false;
          }
          if (
            this.lineType == "success" &&
            flow.data != "menu" &&
            flow.next.success != ""
          ) {
            scope.alertmessage =
              "Only menu will create a multiple success event.";
            scope.alert = true;
            isDroppable = false;
          }
          if (this.lineType == "failure" && flow.next.failure != "") {
            scope.alertmessage = "Only allow one failure event each elements.";
            scope.alert = true;
            isDroppable = false;
          }
        });
        const inputString = id;
        const searchString = "trigger";

        const index_ = inputString.search(new RegExp(searchString));
        let start_point = "voicemail"
        let end_point = "hangup"
        let start_point_validate = this.start.search(new RegExp(start_point));
        let end_point_validate = this.end.search(new RegExp(end_point));
        if (start_point_validate !== -1 && end_point_validate === -1) {
          scope.alertmessage = "Voice Mail Can Only Link With Hangup";
          scope.alert = true;
          isDroppable = false;
        }
        if (index_ !== -1) {
          scope.alertmessage = "No incoming flow to trigger";
          scope.alert = true;
          isDroppable = false;
        } else if (isDroppable) {
          if (this.start.split("-")[2].substring(0, 4) == "menu" && this.end) {
            console.log(
              this.menuItems,
              "2222222222222222222222222222222222222222222222222222222222"
            );
            this.menuItems.push(this.end);
            console.log(
              this.menuItems,
              "2222222222222222222222222222222222222222222222222222222222"
            );
          }
          let line = new LeaderLine.setLine(
            document.getElementById(this.start),
            document.getElementById(this.end),
            {
              path: "grid",
              color: this.lineColor,
              endPlus: "arrow3",
              size: 1.5,
              // endLabel: this.end,
            }
          );
          this.line.splice(this.line.length, 1, line);
          let div = document.querySelector("#div1");
          let lines = document.querySelectorAll(".leader-line");
          lines.forEach((line, index) => {
            // line.style.zoom = div.style.zoom;
            if (this.zoomProperties.current.browser == "chrome") {
              line.style.zoom = div.style.zoom;
            }
            if (this.zoomProperties.current.browser == "firefox") {
              line.style.zoom = div.style.zoom;
              line.style[this.zoomProperties.current.property] =
                this.returnZoom1(this.zoomProperties.current.zoom, 0);
            }
            line.addEventListener("click", () => {
              this.highlightLine(index);
            });
          });
          // this.$emit("addLine", this.line);
          if (this.lineType == "success") {
            if (flow.next.success == "") {
              flow.next.success = this.shapes[index].id;
            } else {
              flow.next.success =
                flow.next.success + "," + this.shapes[index].id;
            }
          }
          if (this.lineType == "failure") {
            flow.next.failure = this.shapes[index].id;
          }
        }
      } catch (e) {
        console.log("Error:==>", e);
      }
    },
    drop(ev) {
      // this function is used to drop only in grid area or (#div1)
      // EDITED BY ABDUL SUBHAN TO REMOVE UN WANTED ELEMENT
      var scope = this;
      var data = ev.dataTransfer.getData("text/html");
      var drp = [
        "audio",
        "menu",
        "dial",
        "hangup",
        "sms",
        "validation",
        "voicemail",
        "connection",
        "conference",
      ];
      console.log(data)
      if (data === "connection") {
        scope.options[data] = {
          conn_method: "",
          conn_type: "",
          conn_api: "",
          api_param: [""],
          api_value: [],
        };
      } else if (data === "validation") {
        scope.options[data] = {
          rules: [
            {
              parameter: "",
              operation: "",
              value: "",
            },
          ],
        };
      } else if (data === "dial") {
        scope.options[data] = {
          dialType: "",
          queue: "",
          DID: "",
          DIDNumber: "",
          users: "",
        };
      } else if (data === "audio") {
        scope.options[data] = {
          audio: "",
          repeat: "",
          timeout: "",
        };
      } else if (data === "conference") {
        scope.options[data] = {
          conf_num: "",
        };
      } else if (data === "menu") {
        scope.options[data] = {
          choices: [],
          files: { menu_invalid: "", menu_valid: "" },
          keys: [],
          repeat: "",
          timeout: "",
        };
      }
      for (var i = 0; i < drp.length; i++) {
        if (drp[i] == data) {
          const zoom = document.getElementById("div1").style.zoom || 100;
          const zoomInt = parseInt(zoom) / 100;
          ev.preventDefault();
          if (ev.target.id != "drag") {
            data = ev.dataTransfer.getData("text/html");
            if (data) {
              if (data !== "hangup" && !scope.elements.includes(data)) {
                scope.elements.push(data);
              }
              var flowName = scope.flow.name;
              var tempArray = flowName.split(" ");
              flowName = tempArray.join("");
              tempArray = flowName.split("-");
              flowName = tempArray.join("");
              scope.shapes.push({
                id: `CTI-${flowName}-${data}${scope.shapeCount}`,
                data: data,
                name: data,
                x: ev.offsetX / zoomInt,
                y: ev.offsetY / zoomInt,
                w: 150,
                h: 100,
                title: `${data.toUpperCase()}`,
                draggable: true,
                description: "Description",
                showFooter: false,
                showCircle: false,
                next: {
                  success: "",
                  failure: "",
                },
                settings: scope.options[data],
                   bgcolor: this.bgcolor[data] || 'white'
              });
              scope.shapeCount += 1;
            }
          }
        }
      }
    }, //////////////////END EDIT/////////////////////////////////
    activated(index, item) {
      // this function is used to get or chech the selected element is active or not
      // EDITED BY ABDUL SUBHAN IN MENU ITEM SELECTION
      this.shapes[index].showCircle = true;
      this.activatedIndex = index;
      this.selectedFlow = index;
      if (item.id.split("-")[2].substring(0, 4) == "menu") {
        if (item.id == this.shapes[index].id) {
          this.menuItems = [];
          var menu = item.next.success.split(",");
          let uniquemenu = [...new Set(menu)];
          for (var i = 0; i < uniquemenu.length; i++) {
            this.menuItems.push(uniquemenu[i]);
          }
          for (i = 0; i < menu.length; i++) {
            item.settings.choices[i] = menu[i];
          }
        }
      }
    },
    menuFiles(val, value, id) {
      console.log(
        "uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu",
        val,
        value,
        id
      );
      if (val == "valid") {
        this.shapes.forEach((shape) => {
          if (shape.id == id) {
            shape.settings.files.menu_valid = this.tenant_code + "_" + value;
          }
        });
      } else if (val == "invalid") {
        this.shapes.forEach((shape) => {
          if (shape.id == id) {
            shape.settings.files.menu_invalid = this.tenant_code + "_" + value;
          }
        });
      }
    },
    // ########################END#################
    // activated(id) {
    //   this.shapes[id].showCircle = true;
    //   this.selectedFlow = id;
    // },
    deActivated(id) {
      this.shapes[id].showFooter = false;
      this.shapes[id].showCircle = false;
    },
    hideFooter(e) {
      if (e.target.id == "div1") {
        this.shapes.forEach((shape) => {
          shape.showFooter = false;
        });
        this.line.forEach((line) => {
          line.outline = false;
        });
      }
    },
    removeFlow(flowIndex, item) {
      // this function is used to removeFlow or file name
      const scope = this;

      scope.shapes.map(function (shape, shape_id) {
        if (shape.data === "menu") {
          let choice__ = [];
          let key__ = [];
          for (let i = 0; i < shape.settings.choices.length; i++) {
            const element = shape.settings.choices[i];

            if (element !== item.id) {
              choice__.push(element);
              key__.push(shape.settings.keys[i]);
            }
          }
          let success = shape.next.success.split(",");
          let fail = shape.next.failure.split(",");

          let successres = success
            .filter((elm) => {
              console.log("failfailfailfailfail", elm, shape.id, item.id);
              if (elm != item.id) {
                return elm;
              }
            })
            .join("','");
          let failres = fail
            .filter((elm) => {
              if (elm != item.id) {
                return elm;
              }
            })
            .join("','");

          shape.next.success = successres;
          shape.next.failure = failres;
          shape.settings.choices = choice__;
          shape.settings.keys = key__;
        }
        console.log(shape, "shapeshapeshapeshapeshape");
        if (shape.next.success === item.id) {
          shape.next.success = "";
        } else if (shape.next.failure === item.id) {
          shape.next.failure = "";
        }
        if (item.id === shape.id) {
          scope.menuItems.splice(item.id, 1);
          scope.shapes.splice(shape_id, 1);
          let removevalue = [];
          for (let i = 0; i < scope.line.length; i++) {
            const element = scope.line[i];
            const endId = element.end.id;
            const startId = element.start.id;

            if (startId == shape.id || endId == shape.id) {
              element.remove();
              removevalue.push(element);
            }
          }
          let resultArray = scope.line.filter(
            (item) => !removevalue.includes(item)
          );
          scope.line = resultArray;
        }
      });
    },
    highlightFlow(id) {
      document.getElementById(id).classList.add("hover");
    },
    unHighlightFlow(id) {
      document.getElementById(id).classList.remove("hover");
    },
    highlightLine(index) {
      this.line.forEach((line) => {
        line.setOptions({
          dash: false,
          size: 1.5,
        });
      });
      this.highlightedFlowIndex = index;
      this.line[index].setOptions({
        dash: {
          animation: true,
        },
        size: 2,
      });
    },
    unHighlightLine(index) {
      this.line[index].setOptions({
        dash: false,
        size: 1.5,
      });
    },

    returnZoom(val, step) {
      let returnval;
      if (this.zoomProperties.current.browser == "chrome") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${this.zoomProperties.current.suffix
          }`;
      }
      if (this.zoomProperties.current.browser == "firefox") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${this.zoomProperties.current.suffix
          }`;
      }

      return returnval;
    },
    returnZoom1(val, step) {
      let returnval;
      if (this.zoomProperties.current.browser == "chrome") {
        returnval = `${this.zoomProperties.current.prefix}${val + step}${this.zoomProperties.current.suffix
          }`;
      }
      if (this.zoomProperties.current.browser == "firefox") {
        returnval = `${this.zoomProperties.current.prefix}1${this.zoomProperties.current.suffix}`;
      }
      return returnval;
    },
    zoomIn() {
      // this function is used zoom in
      console.log("yyyyyyyyyyyyyyyy");
      let div = document.querySelector("#div1");
      let zoom =
        document.querySelector("#div1").style[
        this.zoomProperties.current.property
        ];
      let lines = document.querySelectorAll(".leader-line");
      if (!zoom || zoom === "") {
        div.style["transform-origin"] = "left top";
        div.style[this.zoomProperties.current.property] = this.returnZoom(
          this.zoomProperties.current.zoom,
          0
        );
        if (lines) {
          lines.forEach((line) => {
            line.style[this.zoomProperties.current.property] = this.returnZoom(
              this.zoomProperties.current.zoom,
              0
            );
          });
        }
      }
      if (this.zoomProperties.current.zoom <= this.zoomProperties.current.max) {
        div.style["transform-origin"] = "left top";
        let zoomVal = this.returnZoom(
          this.zoomProperties.current.zoom,
          this.zoomProperties.current.step
        );
        let newZoom =
          this.zoomProperties.current.zoom + this.zoomProperties.current.step;
        this.handleZoom(div, lines, zoomVal, newZoom);
      }
    },
    zoomOut() {
      // this function is used zoom out
      let div = document.querySelector("#div1");
      let zoom =
        document.querySelector("#div1").style[
        this.zoomProperties.current.property
        ];
      let lines = document.querySelectorAll(".leader-line");
      if (!zoom || zoom === "") {
        div.style["transform-origin"] = "left top";
        div.style[this.zoomProperties.current.property] = this.returnZoom(
          this.zoomProperties.current.zoom,
          0
        );
        if (lines) {
          lines.forEach((line) => {
            line.style[this.zoomProperties.current.property] = this.returnZoom(
              this.zoomProperties.current.zoom,
              0
            );
          });
        }
      }
      if (this.zoomProperties.current.zoom >= this.zoomProperties.current.min) {
        div.style["transform-origin"] = "left top";
        var zoomVal = this.returnZoom(
          this.zoomProperties.current.zoom,
          this.zoomProperties.current.step * -1
        );
        let newZoom =
          this.zoomProperties.current.zoom - this.zoomProperties.current.step;
        this.handleZoom(div, lines, zoomVal, newZoom);
      }
    },
    handleZoom(div, lines, zoomVal, newZoom) {
      // this function is used handleZoom event this is main function in zoom
      div.style[this.zoomProperties.current.property] = zoomVal;
      if (lines) {
        lines.forEach((line) => {
          if (this.zoomProperties.current.browser == "chrome") {
            line.style[this.zoomProperties.current.property] = zoomVal;
          }
          if (this.zoomProperties.current.browser == "firefox") {
            line.style[this.zoomProperties.current.property] = this.returnZoom1(
              this.zoomProperties.current.zoom,
              0
            );
          }
        });
      }
      this.line.forEach((line) => {
        console.log("ytttttttttttttttt",line)
        line.position();
      });
      this.zoomProperties.current.zoom = newZoom;
      this.snackbar = true;
    },
    showSnackBar(message) {
      var scope = this;
      scope.Snackbar.show = true;
      scope.Snackbar.text = message;
      setTimeout(() => { }, scope.Snackbar.timeout);
    },
    putJSON() {
      var scope = this;
      scope.generateJSON();
      let widget = scope.flowJSON.data.values;
      let validated_data=validation_function(Object.values(widget))
      if (validated_data.length > 0) {
        scope.showSnackBar("Validation Error In" + validated_data.toString());
      } else {
        let main_arr = []
        let sub_arr = []
        for (let i = 0; i < Object.keys(widget).length; i++) {
          if (Object.keys(widget)[i].data !== 'trigger') {
            main_arr.push(Object.keys(widget)[i])
          }
        }
        for (let j = 0; j < scope.flowJSON.data.connections.length; j++) {
          const element = scope.flowJSON.data.connections[j];
          sub_arr.push(element.end)
        }
        let connection_validate = {}
        for (let k = 0; k < main_arr.length; k++) {
          const element = main_arr[k];
          let filter = sub_arr.filter((e) => {
            if (element === e) {
              return e
            }
          })
          if (filter.length === 0) {
            connection_validate[element] = false
          }
        }
        if (Object.keys(connection_validate).length > 0) {
          scope.showSnackBar("Flow Is Missing");
        }
        else {
          console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
          const id = this.flow_id;
          const payload = { data: scope.flowJSON, flow_id: id };
          console.log(id, payload)
          this.$store
            .dispatch("updateCallFlow", payload)
            .then((response) => {
              scope.isProcessing = false;
              if (response.data.statusCode === 200) {
                scope.showSnackBar("Updating...");
                scope.$router.push({ name: "CallFlow" });
              } else {
                scope.showSnackBar("Create error-" + response.message);
              }
            })
            .catch(function () {
              scope.isProcessing = false;
              scope.showSnackBar("Error Creating Tag");
            });
        }
      }
    },
    generateJSON() {
      try {
        let values = {};
        const flows = this.shapes.slice(1);
        for (var i = 0; i < flows.length; i++) {
          var id = flows[i].id;

          if (
            flows[i].data !== "hangup" &&
            flows[i].settings.choices !== undefined
          ) {
            flows[i].settings.choices = flows[i].next.success.split(",");
          }
          values[id] = flows[i];
        }

        const connections = this.line.map((line) => {
          return {
            end: line.end.id,
            start: line.start.id,
          };
        });
        const variable = this.variables;
        const json = {
          data: {
            start: {
              ...this.shapes[0],
              flowType: "start",
            },
            values,
            connections,
            variable,
          },
        };
        this.flowJSON = json;
        this.$store.dispatch("updateJSON", json);
      } catch (err) {
        console.log(err);
      }
    },
    addMenuSettings(settings, index) {
      let length = settings[settings.length - 1].id + 1;
      this.shapes[index].settings.push({
        id: length,
        value: `${length + 1}`,
        action: "",
      });
    },
    removeMenuSettings(footer, index) {
      this.shapes[footer].settings.splice(index, 1);
    },
    // dragEnd(x, y) {
    // this.shapes[this.activatedIndex].x = x;
    // this.shapes[this.activatedIndex].y = y;
    // }
  },
  // updated() {
  //     if (this.lines.length > 0) {
  //         this.lines.forEach(line => {
  //             const id = line.end.id.split("-")[1];
  //             if (id != this.flow.name) {
  //                 line.hide();
  //             } else {
  //                 line.show();
  //             }
  //         });
  //     }
  // },
  watch: {
    showJSON(val) {
      this.showJSONComponent = val;
      if (val) {
        this.generateJSON();
      }
    },
    did_numbers(val) {
      let arr = val.split("");
      let validdata = "";
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];

        if (!isNaN(Number(element))) {
          validdata += element;
        }
      }
      this.did_numbers = validdata;
      this.shapes.forEach((shape) => {
        if (shape.data === "trigger") {
          shape.settings.did = validdata;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["getJSON", "updateJSON"]),
    zoomalert() {
      return (
        this.zoomProperties.current.zoom * this.zoomProperties.current.unit +
        "%"
      );
    },
    dialVariables() {
      let temp = ["DID Number", 'Dial Status',"Caller", "Agent"];
      return this.variables.filter((e) => {
        return !temp.includes(e);
      });
    },
  },

  beforeDestroy() {
    this.line.forEach((item) => {
      item.remove();
    });
  },
};
</script>
<style>
body {
  overflow: hidden;
}

body .leader-line {
  pointer-events: auto;
}

.header {
  border-width: 1px 0 1px;
  border-style: solid;
}

.hover {
  border: 1.5px solid red;
}

.controls {
  position: fixed;
  display: flex;
  bottom: 10px;
  right: 0px;
}

.controls i {
  display: block;
  color: #fff !important;
  background: #424242;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  text-align: center;
  padding: 10px 0;
  margin: 10px 0;
}

.zoom_button_class {}

.zoom-in-bts,
.zoom-out-bts {
  top: 650px;
  width: 40px !important;
  height: 40px !important;
  min-width: 40px;
}

.zoom-in-bts {
  right: 30px;
}

.zoom-out-bts {
  right: 80px;
}

.flow {
  box-shadow: 1px 1px 13px #999;
  position: absolute;
  border-radius: 5px;
}

.draggable.resizable.flow.active,
.check.highlight {
  box-shadow: 1px 1px 14px #666;
}

/* .v-tooltip__content {
  background: #fcbe03;
  color: red;
} */
.check.highlight>.custom-handle {
  display: block !important;
}

.v-tooltip__content--fixed {
  top: 260px !important;
}

.mainViewFlex {
  display: flex;
  flex-direction: column;
  background-image: url(../../CallFlow/create/options/Dummy_dots.svg)
}

.list_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.nav_component {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100px;
  padding: 3px;
}

.nav_component:hover {
  background-color: #e4dede;
  border-radius: 5px;
}

.icon-txt {
  width: 100px;
  text-align: center;
}

.nav_items {
  text-align: center;
}

.navbarcomponent {
  padding: 5px;
  z-index: 2;
  position: relative;
  background-color: white;
  border: 1px solid #cacaca;
}

.upl_btn {
  display: flex;
  justify-content: right;
  padding: 0px 225px 0px 10px;
  
  /* position: relative; */
  background-color: #ffffff;
  border: 1px solid #cacaca;
  margin-bottom: 30px;
 
  position: fixed !important;
  top: 562px !important;
  width: 100% !important;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;

  z-index: 1;
  position: relative;
 

}


.bts_clss {
  margin: 10px;
  width: 90px;
  height: 35px;
  max-height: 60px;
  border-radius: 5px;
}

.input_ {
  margin: 10px !important;
}

.accent {
  background-color: #f7f7f7 !important;
  border-color: #f7f7f7 !important;
}

.tabflex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  background-color: #2194f3 !important;
  color: #ffffff;
  text-align: center;
}

.tabitem {
  background-color: #ffffff !important;
  color: #000000;
}

.tabitempadding {
  cursor: pointer;
  padding: 10px;
}

.custom-input {
  width: 100% !important;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.42);
  /* border-radius: 5px; */
  font-size: 16px;
  margin-bottom: 10px;
  outline: none;
  border-top: none;
  border-left: none;
  border-right: none;
  transition: border-color 0.2s;
}

.custom-input:focus {
  border-color: #007bff;
}

.validation_row {
  width: 100%;
  border: 1px solid #cacaca;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 5px;
  /* display: flex;
  flex-direction: row; */
}

.validationheader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
}

.add-button {
  width: 100%;
  padding: 5px;
  background-color: #2194f3;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
}
.zoom{height: 500vh !important;}
.add-button:hover {
  background-color: #2194f3;
}
.menu {
  color: #4a4a4a !important;
}

.audio {
  color: #ffa500 !important;
}

.sms {
  color: #1da1f2 !important;
}

.voice {
 
  color: #8a2be2 !important;
}

.validation {
  color: #28a745 !important;
}

.connection {
  color: #20c997 !important;
}

.conference {
  color: #20c997 !important;
}

.dial {
  color: #32cd32 !important
}

.hangup {
  color: #ff4b4b !important
}
.zoom{height: 8000vh !important; }

/* @media screen and (max-width: 1920px) and (max-height:1000px){
  .upl_btn {
  display: flex;
  justify-content: right;
  padding: 0px 225px 0px 10px;
  
 
  background-color: #ffffff;
  border: 1px solid #cacaca;
  margin-bottom: 30px;
 
  position: fixed !important;
  top: 53px !important;
  width: 100% !important;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;

  z-index: 1;
  position: relative;
 

}
}
@media screen and (min-width: 1435px) and (min-height:620px){
  .upl_btn {
  display: flex;
  justify-content: right;
  padding: 0px 225px 0px 10px;
  
 
  background-color: #ffffff;
  border: 1px solid #cacaca;
  margin-bottom: 30px;
 
  position: fixed !important;
  top: 562px !important;
  width: 100% !important;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;

  z-index: 1;
  position: relative;
 

}
}
@media screen and (min-width: 1280px) and (min-height:800px){
  .upl_btn {
  display: flex;
  justify-content: right;
  padding: 0px 225px 0px 10px;
  
 
  background-color: #ffffff;
  border: 1px solid #cacaca;
  margin-bottom: 30px;
 
  position: fixed !important;
  top: 584px !important;
  width: 100% !important;
  display: flex;
  -webkit-box-pack: right;
  -ms-flex-pack: right;
  justify-content: right;

  z-index: 1;
  position: relative;
 

}
} */


/* Styles for screens up to 1920px (overrides the previous if both are true) */
/* @media screen and (max-width: 1435px) and (max-height: 620px) {
  .upl_btn {
    top: 562px !important;
    
  }
} */
@media screen and (min-width: 1280px) and (min-height:550px){
  .upl_btn {
    top: 500px !important;
    
  }
}
@media screen and (min-width: 1435px){
  .upl_btn {
    top: 692px !important;
    
  }
}
@media screen and (min-width: 1480px)  {
  .upl_btn {
    top: 689px !important;
    
  }
}
@media screen and (min-width: 1643px)  {
  .upl_btn {
    top: 777px !important;
    
  }
}
@media screen and (min-width: 1700px)  {
  .upl_btn {
    top: 777px !important;
    
  }
}
@media screen and (min-width: 1849px)  {
  .upl_btn {
    top: 880px !important;
    
  }
}
@media screen and (min-width: 1913px)  {
  .upl_btn {
    top: 770px !important;
    
  }
}

@media screen and (min-width: 1920px) {
  .upl_btn {
    top: 942px !important; 
  }
}
@media screen and (min-width: 2218px) {
  .upl_btn {
    top: 1066px !important; 
  }
}
@media screen and (min-width: 2958px) {
  .upl_btn {
    top: 1437px !important; 
  }
}














</style>
